module.exports = __webpack_public_path__ + "img/bordeaux.4f40532f.png";